// Storage related functions in case we need to change localStorage

export const getBeaconIds = () => {

    let sid = window.localStorage.getItem('sid');
    let uid = window.localStorage.getItem('uid');

    if (sid === 'undefined') {
        sid = undefined;
    }
    if (uid === 'undefined') {
        uid = undefined;
    }

    return {
        sid, uid
    }
}

export const setBeaconIds = ({ sid, uid }) => {
    window.localStorage.setItem('sid', sid);
    window.localStorage.setItem('uid', uid);
}